import { useExperience } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Button, Card, Icon, Text } from '@cascade/ui-library';
import { useNavigate } from 'react-router-dom';
import classes from './ExperienceFailed.module.scss';
import { Page } from '#components/page/index.ts';
import { HOME_PATH } from '#config/index.ts';

export const ExperienceFailed = () => {
  const { translate, translateError } = useI18n();
  const { experienceError, reloadExperience } = useExperience();
  const navigate = useNavigate();

  const showRetry = Boolean(experienceError);
  const message = experienceError
    ? translateError(experienceError)
    : translate('experience.failed.noSteps');

  const navigateHome = () => navigate(HOME_PATH, { replace: true });

  return (
    <Page>
      <Card
        className={classes['experience-failed']}
        padding='xl'
        borderRadius='xl'
      >
        <div className={classes.body}>
          <Icon type='triangle-exclamation' color='text-warning' size='3xl' />
          <Text
            type='h3'
            weight='semibold'
            content={translate('experience.failed.title')}
            compact
          />
          <Text type='body-2' color='text-60' role='alert' content={message} />
          <div className={classes.actions}>
            <Button
              variant={showRetry ? 'secondary' : 'primary'}
              ghost={showRetry}
              label={translate('experience.home')}
              onClick={navigateHome}
            />
            {showRetry ? (
              <Button
                label={translate('experience.failed.retry')}
                onClick={reloadExperience}
              />
            ) : null}
          </div>
        </div>
      </Card>
    </Page>
  );
};
